import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CompanyContextService } from '../../../services/company-context.service';

/**
 * Read-only summary of the company the shell resolved.
 *
 * Deliberately has no action buttons — the tab bar directly above already
 * navigates to impersonate, bulk import and the audit log.
 */
@Component({
  selector: 'app-company-overview',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="company-overview" *ngIf="context.current$ | async as company">
      <dl class="company-overview__grid">
        <div class="company-overview__field">
          <dt>Email</dt>
          <dd>{{ company.email || '—' }}</dd>
        </div>
        <div class="company-overview__field">
          <dt>Contact</dt>
          <dd>{{ company.contact || company.phone || '—' }}</dd>
        </div>
        <div class="company-overview__field">
          <dt>Address</dt>
          <dd>{{ company.address || '—' }}</dd>
        </div>
        <div class="company-overview__field">
          <dt>Locations</dt>
          <dd>{{ locationsLabel(company.no_of_locations) }}</dd>
        </div>
        <div class="company-overview__field">
          <dt>Timezone</dt>
          <dd>{{ company.timezone || '—' }}</dd>
        </div>
        <div class="company-overview__field">
          <dt>Created</dt>
          <dd>{{ formatDate(company.created_at) }}</dd>
        </div>
        <div class="company-overview__field">
          <dt>Admin account</dt>
          <dd>{{ company.admin_name || company.admin_email || '—' }}</dd>
        </div>
      </dl>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [
    `
      .company-overview__grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
        gap: 1rem 1.5rem;
        margin: 0;
        padding: 1.25rem;
        background: var(--white, #fff);
        border: 1px solid var(--gray-200, #e5e7eb);
        border-radius: 10px;
      }
      .company-overview__field {
        min-width: 0;
      }
      .company-overview__field dt {
        font-size: 0.75rem;
        text-transform: uppercase;
        letter-spacing: 0.03em;
        color: var(--gray-500, #6b7280);
        margin-bottom: 0.25rem;
      }
      .company-overview__field dd {
        margin: 0;
        color: #111827;
        font-size: 0.95rem;
        overflow-wrap: anywhere;
      }
    `,
  ],
})
export class CompanyOverviewComponent {
  readonly context = inject(CompanyContextService);

  locationsLabel(count?: number): string {
    if (count === null || count === undefined) {
      return '—';
    }
    return `${count} location${count === 1 ? '' : 's'}`;
  }

  formatDate(value?: string): string {
    if (!value) {
      return '—';
    }
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? '—' : date.toLocaleDateString();
  }
}
